import getLimits from './get-limits';
import getSettings from './get-settings';
import getUserData from './get-user-data';

export default {
  getLimits,
  getSettings,
  getUserData,
};
